jQuery(document).ready(function(){
  
 
  
    $('.carret').click(function(){
      $(this).siblings('.mobile_nav ul.sub_menu ').toggle();
      $(this).parent("li ").siblings().children(".mobile_nav ul.sub_menu").hide();
    });
   
   if ($(window).width() < 992) {
      $('.slidedown_section a').on('click', function (e) { 
         e.preventDefault();
        e.stopPropagation();
        $('#slidedown-modal').slideToggle();
    });
     $('#slidedown-modal').on("click", function (e) {
        e.stopPropagation();
    });
     $(document).on("click", function () {
        $('#slidedown-modal').hide();
    });
   }


  $('.sub_menu').before('<span class="menu_arrow"></span>');
  $('.menu_arrow').click(function(){ 
    //$(this).parent().children('.sub_menu').slideToggle();

    $(this).siblings("ul").slideToggle();
    $(this).parent(".menu_item  li ").siblings().children("ul").hide();
    $(this).siblings('ul').children('li').children('ul').hide();
  });  
  
  
  var feed = new Instafeed({ 
    get: $('#ins_get').val(),    
    tagName: $('#ins_tag').val(),             
    userId: parseInt($('#userid').val()), 
    accessToken:  $('#access').val(),  
    resolution: $('#r_images').val(),  
    clientId: $('#clientid').val(),   
    limit: $('#limit').val(), 
    template:'<li><a href="{{link}}" class="ins_img" target="_blank"><img src="{{image}}"/></a></li>',
    after: function() {
      $('.insta_slider3').flexslider({
        animation: "slide",
        animationLoop: false, 
        itemWidth: 287,
        itemMargin:10,
        minItems: 2,
        maxItems:2,
        controlNav:false,
        move:1,
        animationLoop:false,
        slideshow:false  ,
        start:function(){
          $('.insta_slider3 .ins_img').css('height',$('.insta_slider3 .ins_img').width());
        }
      });
      $('.insta_slider3 .ins_img').css('height',$('.insta_slider3 .ins_img').width());
    }
  });              
  feed.run();
  
 

  
});
$(window).resize(function(){
  $('.insta_slider3 .ins_img').css('height',$('.insta_slider3 .ins_img').width());
});